module.exports = __webpack_public_path__ + "static/img/closea.516bf3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/closea.png
// module id = RC9g
// module chunks = 0